module.exports = __webpack_public_path__ + "img/icon_5.fa6a6d5f.svg";